import { FC } from "react";
import LoginView from "./login.view";

const LoginViewRoot: FC = () => <LoginView />;

export default LoginViewRoot;
